import { useMutation } from "@apollo/client/react";
import NetworkStateContext from "contexts/NetworkStateContext";
import useFetchShiftInstances from "hooks/apollo/shiftInstance/useFetchShiftInstances";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import { useContext } from "react";
import GqlError from "utils/GqlError";
import { SplitWorkBlockAcrossShifts } from "./workBlock.gql";

export default function useSplitWorkBlockAcrossShifts() {
  const { trackLoadingState } = useContext(NetworkStateContext);
  const { refetch: refetchShiftInstances } = useFetchShiftInstances();
  const { setNotification } = useNotificationState();
  const [splitWorkBlockAcrossShifts] = useMutation(SplitWorkBlockAcrossShifts, {
    onCompleted: () => {
      refetchShiftInstances();
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to split work block",
          type: "danger",
        });
      });
    },
  });

  return (workBlock) =>
    trackLoadingState("SPLIT_BLOCKS", () =>
      splitWorkBlockAcrossShifts({
        variables: {
          workBlockId: workBlock.id,
        },
      }),
    );
}
